import React from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import AdminFooter from "../components/AdminFooter";

export default function AdminLayout(){
const [mobileOpen,setMobileOpen] = React.useState(false);

return(

<Box sx={{display:"flex", minHeight:"100vh", backgroundColor:"#0a446e"}}>

<Sidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />

<Box
sx={{
flex:"1 1 auto",
minWidth:0,
minHeight:"100vh",
display:"flex",
flexDirection:"column",
width:"auto",
maxWidth:"100%",
overflowX:"hidden"
}}
>

<Topbar onOpenMenu={() => setMobileOpen(true)} />

<Box
sx={{
px:0,
py:{ xs:2, sm:3 },
pt:{ xs:"84px", sm:"92px" },
flexGrow:1,
width:"100%",
maxWidth:"100%",
overflowX:"hidden",
mx:"auto",
minWidth:0
}}
>
<Outlet/>
</Box>

<AdminFooter/>

</Box>

</Box>

)

}
